import useApiCall from '@/hooks/useApiCall';
import { Tabs } from '@data-products-and-ai/react-components';
import { useEffect, useState } from 'react';

import { TPartSearch } from '../Part/types';

import { CONSTANTS } from '@/constants/constants';
import { useNavigate, useParams } from 'react-router-dom';
import { TPartApprovalStatus } from '../Frame/types';
import { SearchResultsTable } from '../Parts/components/SearchResultsTable';
import { Spinner } from '@/components/Spinner';
import useGroups from '@/hooks/useGroups';
import { NoPermission } from '@/components/NoPermission';

const DataQuality = () => {
  document.title = CONSTANTS.en.TITLE + ' - Data Quality';

  const navigate = useNavigate();
  const groups = useGroups();
  const { status } = useParams();
  const { isLoading, error, data, makeApiCall } = useApiCall<TPartSearch>();

  const [selectedOption, setSelectedOption] = useState<TPartApprovalStatus>(
    status ? (status.toUpperCase() as TPartApprovalStatus) : 'PENDING',
  );

  useEffect(() => {
    const filter = '?status=' + selectedOption;

    makeApiCall({
      method: 'GET',
      url: import.meta.env.VITE_APP_API_URL + '/parts' + filter,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);

  type TOption = {
    key: TPartApprovalStatus;
    label: string;
  };

  const options: TOption[] = [
    { key: 'PENDING', label: 'Waiting for approval' },
    { key: 'POSTPONED', label: 'Postponed' },
    { key: 'REJECTED', label: 'Rejected' },
  ];

  const handleTabs = (value: TPartApprovalStatus) => {
    let status: string = '/' + value.toLowerCase();

    //if PENDING just navigate to data_quality root
    if (value === 'PENDING') status = '';

    navigate('/data_quality' + status, { replace: true });

    setSelectedOption(value);
  };

  if (groups && !groups.includes(import.meta.env.VITE_AZURE_ADMIN_GROUP))
    return <NoPermission />;

  return (
    <div className="contentContainer">
      <div style={{ marginBottom: 40 }}>
        <Tabs
          centered={false}
          data={options}
          selectedKey={selectedOption}
          fontSize={14}
          onChange={handleTabs}
        />
      </div>
      {isLoading && (
        <div
          className="contentContainer"
          style={{
            display: 'flex',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner borderSize={8} size={64} color="#CCCCCC" />
        </div>
      )}
      {error && <div>Error: {error.message}</div>}
      {data && !isLoading && (
        <SearchResultsTable
          key="results"
          parts={data.parts}
          status={selectedOption}
        />
      )}
    </div>
  );
};

export default DataQuality;
